class SystemLibraryCache {
  constructor() {
    this.cache = new Map();
  }

  generateCacheKey(product, searchParts) {
    const keyData = {
      product,
      parts: searchParts.map(part => ({
        part: part.part,
        info: part.info
      }))
    };
    return JSON.stringify(keyData);
  }

  get(cacheKey) {
    return this.cache.get(cacheKey);
  }

  set(cacheKey, data) {
    this.cache.set(cacheKey, data);
  }

  delete(cacheKey) {
    this.cache.delete(cacheKey);
  }

  clear() {
    this.cache.clear();
  }
}

const systemLibraryCache = new SystemLibraryCache();

export default systemLibraryCache;